import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { useLocation } from 'react-router-dom';

import {
    clientBodyStyle,
    appContainerStyle,
    clientSmallWrapperStyle,
    clientBigWrapperStyle
} from 'client/styles/common';
import { isSmallPromoWidth } from 'config/promoGameTypes';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';
import { usePushLoginEvent } from 'client/hooks/login/usePushLoginEvent';
import Loading from 'client/components/Loading';
import LoadingPromoInit from 'client/components/LoadingPromoInit';
import Background from 'client/components/Background';
import PowerBy from 'client/components/PowerBy';
import TaskRecordHeader from 'client/components/TaskRecordHeader';
import { fromEntries } from 'utils/core';
import FooterActionButton from 'client/components/FooterActionButton';

const ClientWrapper = ({ children }) => {
    usePushLoginEvent();
    const clientBodyRef = useHeightResizePostMessage();
    const { hasInited, hasUserStateInited, hasErrorOnInit } = useSelector(s => s.flags);
    const { shouldGetNextEntry, shouldHideUserStateLoading } = useSelector(s => s.userEntryState);
    const { isWidgetEmbedded, isZinesEmbedded } = useSelector(s => s.appState);
    const { isCoverPagePhase } = useSelector(s => s.userEntryState);
    const { type } = useSelector(s => s.promo);
    const location = useLocation();
    const isBigWidthPage = checkPage(getFinalPath(location));
    const isIniting = !hasInited && !hasErrorOnInit;
    const isInitingUserState = hasInited && !hasUserStateInited && !hasErrorOnInit;
    const canRenderContent = hasInited || hasErrorOnInit;
    const params = new URLSearchParams(location.search);
    const shouldDisplayBackToMultiChallengeTaskPromo =
        params.has('taskUuid') && params.has('promoUuid');
    const isPromoEmbeddedWidgetWithoutZines = isWidgetEmbedded && !isZinesEmbedded;

    return (
        <>
            {!isInitingUserState && <Background />}
            {isIniting && <LoadingPromoInit />}
            {isInitingUserState && !shouldGetNextEntry && !shouldHideUserStateLoading && (
                <Loading />
            )}
            {shouldGetNextEntry && (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        zIndex: 99,
                        backgroundImage:
                            'url(https://assets.fevercdn.com/promotion/img/loading-ellipsis.svg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}
                ></div>
            )}
            <div
                id="promo-client-body"
                css={css([clientBodyStyle, isPromoEmbeddedWidgetWithoutZines && centralPromoStyle])}
                ref={clientBodyRef}
            >
                <div
                    css={[
                        css(appContainerStyle),
                        !isSmallPromoWidth(type) && isBigWidthPage
                            ? css(clientBigWrapperStyle)
                            : css(clientSmallWrapperStyle),
                        isCoverPagePhase && coverFgStyle,
                        isPromoEmbeddedWidgetWithoutZines && css(fullScreenPromoStyle),
                        shouldDisplayBackToMultiChallengeTaskPromo &&
                            clientWrapperIncludeAdditionalHeaderStyle
                    ]}
                >
                    <TaskRecordHeader {...fromEntries(params)} />
                    {canRenderContent && children}
                    <FooterActionButton isCoverPagePhase={isCoverPagePhase} />
                </div>
                <PowerBy />
            </div>
        </>
    );
};

export default ClientWrapper;

ClientWrapper.propTypes = {
    children: PropTypes.node
};

function getFinalPath(location) {
    const pathName = location.pathname;
    const splitPath = pathName.split('/');
    return splitPath[3];
}
function checkPage(page) {
    if (page === 'join' || page === 'result' || page === 'prize') {
        return true;
    } else {
        return false;
    }
}

const centralPromoStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const fullScreenPromoStyle = css`
    width: 100%;
    height: 100vh;
`;

const clientWrapperIncludeAdditionalHeaderStyle = css`
    padding-top: 0px;

    @media only screen and (max-width: 720px) {
        padding-top: 0px;
    }

    @media only screen and (max-width: 767px) {
        padding-top: 0px;
    }
`;

const coverFgStyle = css`
    max-width: 720px;
`;
